import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { MsalGuard } from "@azure/msal-angular";

import { NotFoundView } from "./common";
import { Home } from "./home/home";
import { SecurityListView, SecurityEditorView, SecurityDetailView } from "./security";
import { ManifestDetailView, ManifestListView, ManifestPropertyEditorView } from "./manifest";
import { ContainerDetailView, ContainerEdit, ContainerListView } from "./container";
import { ItemDetail, ItemEdit, ItemListView } from "./item";
import {
  ContainerTypesView,
  FacilitiesView,
  FacilityTypesView,
  FormCodesView,
  ItemContainerMaterialsView,
  ManagementCodesView,
  ProcessCategoriesView,
  SourceCodesView,
  TsdfCodesView,
  UnitsView,
} from "./auxiliary";
import { TransportersView } from "./auxiliary/transporters-view";
import { WasteStreamView } from "./auxiliary/waste-stream-view";

const routes: Routes = [
  {
    // Needed for hash routing
    path: "code",
    component: Home,
    canActivate: [MsalGuard],
  },
  {
    path: "",
    component: Home,
    canActivate: [MsalGuard],
  },
  {
    path: "manifests",
    canActivate: [MsalGuard],
    children: [
      { path: "", component: ManifestListView },
      { path: "new", component: ManifestPropertyEditorView },
      { path: ":manifestId", component: ManifestDetailView },
      { path: ":manifestId/edit", component: ManifestPropertyEditorView },
      { path: ":manifestId/edit/:containerId/edit", component: ContainerEdit },
      { path: ":manifestId/newncontainer", component: ContainerEdit },
      { path: ":manifestId/edit/:containerId", component: ContainerDetailView },
    ],
  },
  {
    path: "containers",
    canActivate: [MsalGuard],

    children: [
      { path: "", component: ContainerListView },
      { path: "new", component: ContainerEdit },
      { path: ":containerId", component: ContainerDetailView },
      { path: ":containerId/edit", component: ContainerEdit },
    ],
  },
  {
    path: "items",
    canActivate: [MsalGuard],
    children: [
      { path: "", component: ItemListView },
      { path: "new", component: ItemEdit },
      { path: ":itemId", component: ItemDetail },
      { path: ":itemId/edit", component: ItemEdit },
    ],
  },
  {
    path: "facilitytypes",
    canActivate: [MsalGuard],
    children: [{ path: "", component: FacilityTypesView }],
  },
  {
    path: "sourcecodes",
    canActivate: [MsalGuard],
    children: [{ path: "", component: SourceCodesView }],
  },
  {
    path: "formcodes",
    canActivate: [MsalGuard],
    children: [{ path: "", component: FormCodesView }],
  },
  {
    path: "units",
    canActivate: [MsalGuard],
    children: [{ path: "", component: UnitsView }],
  },
  {
    path: "processcategories",
    canActivate: [MsalGuard],
    children: [{ path: "", component: ProcessCategoriesView }],
  },
  {
    path: "itemcontainermaterials",
    canActivate: [MsalGuard],
    children: [{ path: "", component: ItemContainerMaterialsView }],
  },
  {
    path: "containertypes",
    canActivate: [MsalGuard],
    children: [{ path: "", component: ContainerTypesView }],
  },
  {
    path: "tsdfcodes",
    canActivate: [MsalGuard],
    children: [{ path: "", component: TsdfCodesView }],
  },
  {
    path: "facilities",
    canActivate: [MsalGuard],
    children: [{ path: "", component: FacilitiesView }],
  },
  {
    path: "transporters",
    canActivate: [MsalGuard],
    children: [{ path: "", component: TransportersView }],
  },
  {
    path: "managementcodes",
    canActivate: [MsalGuard],
    children: [{ path: "", component: ManagementCodesView }],
  },
  {
    path: "wastestreams",
    canActivate: [MsalGuard],
    children: [{ path: "", component: WasteStreamView }],
  },
  {
    path: "security",
    canActivate: [MsalGuard],
    children: [
      { path: "", component: SecurityListView },
      { path: "new", component: SecurityEditorView },
      { path: ":roleId", component: SecurityDetailView },
      { path: ":roleId/edit", component: SecurityEditorView },
    ],
  },

  { path: "**", component: NotFoundView },
];
const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      // Don't perform initial navigation in iframes
      initialNavigation: !isIframe ? "enabledBlocking" : "disabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
